import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SequenceCardComponent } from '../sequence/sequence-card/sequence-card.component';
import { FlightDetailsComponent } from '../flight-details/flight-details.component';
import { CalendarCardComponent } from '../calendar/calendar-card/calendar-card.component';
import { RedirectComponent } from '@shared/components/redirect/redirect.component';
import { DateTime } from 'luxon';
import { FlightSearchComponent } from '@calendar/flight-search/flight-search.component';
import { LookupSeqComponent } from '@calendar/flight-search/lookup-seq/lookup-seq.component';

// Retrieve last URL from local storage. If the timestamp is less than 24 hours old, use this
// URL as default. Otherwise use calendar as default.
const getDefaultRoute = (): string => {
  const PREV_URL_EXPIR_MINUTES = 24 * 60;
  const prevUrl = localStorage.getItem('lastUrl');
  const prevUrlTime = localStorage.getItem('lastUrlTime');

  if (prevUrl && prevUrlTime) {
    if (
      DateTime.fromISO(prevUrlTime).diffNow('minutes').minutes * -1 <
      PREV_URL_EXPIR_MINUTES
    ) {
      return prevUrl;
    }
  }

  return 'calendar';
};

const routes: Routes = [
  {
    path: '',
    redirectTo: getDefaultRoute(),
    pathMatch: 'full',
  },
  {
    path: 'calendar/:employeeNumber',
    component: CalendarCardComponent,
    data: {
      animation: 'Calendar',
      screenIndex: 1,
    },
  },
  {
    path: 'calendar',
    component: CalendarCardComponent,
    data: {
      animation: 'Calendar',
      screenIndex: 1,
    },
  },
  {
    path: 'sequence/:number/:seat/:seqDate',
    component: SequenceCardComponent,
    data: {
      animation: 'Sequence',
      screenIndex: 2,
    },
  },
  {
    path: 'sequence/:number/:seat/:seqDate/flight/:flightNumber/:depAirport/:arrAirport/:flightDate',
    component: FlightDetailsComponent,
    data: {
      animation: 'FlightDetail',
      screenIndex: 3,
    },
  },
  {
    path: 'search',
    component: FlightSearchComponent,
    data: {
      animation: 'FlightDetail',
      screenIndex: 4,
    },
  },
  {
    path: 'lookup-sequence/:flightNumber/:dep/:arr/:date',
    component: LookupSeqComponent,
    data: {
      animation: 'FlightDetail',
      screenIndex: 4,
    },
  },
  {
    path: 'redirect',
    component: RedirectComponent,
  },
  {
    path: '**',
    redirectTo: 'calendar',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableViewTransitions: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  getDefaultRoute(): string {
    return 'calendar';
  }
}
